<template>
  <div>
    <div class="flex-fill d-flex flex-column justify-content-center">
      <div class="container-tight py-6">
        <div class="text-center mb-4 mt-4">
          <a href="/"
            ><img
              :src="require('../assets/images/logo-dark.png')"
              height="36"
              alt=""
          /></a>
        </div>
        <form class="card card-md" @submit.prevent="signin">
          <div class="card-body">
            <h2 class="mb-5 text-center">忘記密碼</h2>
            <div class="alert alert-danger" v-show="error" role="alert">
              {{ errorMsg }}
            </div>
            <div class="alert alert-success" v-show="success" role="alert">
              {{ successMsg }}
            </div>
            <div class="mb-3">
              <label class="form-label">Email</label>
              <input
                type="email"
                class="form-control"
                placeholder="Email"
                autocomplete="off"
                v-model="email"
              />
            </div>
            <div class="form-footer">
              <button type="submit" class="btn btn-primary w-100">
                寄送重設密碼信
              </button>
            </div>
          </div>
        </form>
        <div class="text-center text-muted mt">
          已經有帳號?
          <router-link to="/login">登入</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  data() {
    return {
      email: "",
      errorMsg: "",
      error: false,
      successMsg: "",
      success: false,
    };
  },
  methods: {
    async signin() {
      if (this.email == "") {
        this.error = true;
        this.errorMsg = "不得為空";
      } else {
        const api = `${process.env.VUE_APP_API_URL}/api/${process.env.VUE_APP_API_VERSION}/merchant/me/forgetPassword`;
        try {
          const response = await this.$http.patch(api, { email: this.email });
          if (response.data.status == "success") {
            this.error = false;
            this.success = true;
            this.successMsg = "請至您的信箱查看重設密碼信件";
            this.email = "";
          } else {
            this.success = false;
            this.error = true;
            this.errorMsg = "錯誤";
          }
        } catch (err) {
          this.error = true;
          if (typeof err.response === "undefined") {
            this.errorMsg = "錯誤";
          } else if (err.response.data.message === "not found") {
            this.error = false;
            this.success = true;
            this.successMsg = "請至您的信箱查看重設密碼信件";
          } else {
            this.errorMsg = err.response.data.message;
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.page {
  padding-top: 100px;
}
</style>
